import { render, staticRenderFns } from "./FieldSalesDashboard.vue?vue&type=template&id=6045b620&scoped=true"
import script from "./FieldSalesDashboard.vue?vue&type=script&lang=js"
export * from "./FieldSalesDashboard.vue?vue&type=script&lang=js"
import style0 from "./FieldSalesDashboard.vue?vue&type=style&index=0&id=6045b620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6045b620",
  null
  
)

export default component.exports